import { ReactElement } from 'react';
import BaseCrrTimeOfDayPlot from './BaseCrrTimeOfDayPlot';

interface CrrTimeOfDayPlotProps {
  session: any;
  equipmentCatalog: any;
  pressureUnit: 'Bar' | 'PSI';
  height?: number;
}

/**
 * Crr vs Time of Day plot showing temperature-adjusted Crr values (Crr_xG5)
 */
export default function CrrTimeOfDayPlot({
  session,
  equipmentCatalog,
  pressureUnit,
  height = 400,
}: CrrTimeOfDayPlotProps): ReactElement {
  return (
    <BaseCrrTimeOfDayPlot
      session={session}
      equipmentCatalog={equipmentCatalog}
      pressureUnit={pressureUnit}
      height={height}
      title="Crr vs Time of Day"
      yAxisTitle="Crr <br>(Temperature Adjusted)"
      hoverLabel="Crr Average"
      noDataMessage="No Crr time data available"
      fixedYAxisSpan={0.003}
      traceSuffix="avg"
      dataFieldConfig={{
        traverseSource: 'traverse',
        traverseField: 'Crr_xG5',
        averageSource: 'average',
        averageField: 'Crr_xG5',
      }}
    />
  );
}
